/* eslint-disable */
import React, { useState } from 'react';
import LoadingContainer from 'Containers/LoadingContainer';
import Row from './Row.js';
import style from './style';
import useTranslation from 'Hooks/useTranslation';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  Paper,
  TablePagination,
  TableRow,
} from '@mui/material';
import { COURSE_STATUS_APPROVED_NAME } from 'Constants/General.js';

const { tableContainerStyle, tableStyle, tableHead, tableCellStyle, tablePaginationStyle } = style;

export default function BasicTable({
  headers = [],
  information = [],
  limit = information.length,
  thereIsComponent = null,
  expandible = null,
  configButton = [],
  configButtonEvents = [],
  editButton = false,
  editButtonEvent = () => {},
  restartButton = false,
  restartButtonEvent = () => {},
  widthColumn = null,
  clickable = null,
  clickAction = () => {},
  isLoading = false,
  isAdmin = false,
}) {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [count, setCount] = useState(information.length);
  const { t2 } = useTranslation('Table');
  if (count != information.length) {
    setCount(information.length);
    setPage(0);
  }

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = event => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  if (information.length === 0) return <LoadingContainer isLoading={isLoading}>{t2('NoData')}</LoadingContainer>;

  return (
    <div className="col" style={{ flex: 1, width: '100%' }}>
      <TableContainer component={Paper} style={tableContainerStyle} elevation={0} className="col">
        <Table sx={tableStyle}>
          <TableHead sx={tableHead}>
            <TableRow>
              {headers.map((header, index) => (
                <TableCell key={index} align="center" sx={tableCellStyle}>
                  {header}
                </TableCell>
              ))}
              {configButton.length ? <TableCell align="center" /> : null}
            </TableRow>
          </TableHead>
          <TableBody>
            {information.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, index) => {
              // La variable canApprove es para saber si el usuario puede aprobar el curso
              // siempre y cuando no este aprobado el curso y sea un administrador
              let canApprove = false;

              // Obtenemos el nombre del estatus del curso
              const statusName = row?.[3];

              if (statusName) {
                canApprove = isAdmin && statusName !== COURSE_STATUS_APPROVED_NAME;
              }

              return (
                <Row
                  key={row[0] + index}
                  row={row}
                  limit={limit}
                  thereIsComponent={thereIsComponent}
                  expandible={expandible}
                  clickable={clickable}
                  clickAction={clickAction}
                  configButtonEvents={row[6] ? configButtonEvents : []}
                  configButton={row[6] ? configButton : []}
                  editButton={editButton || canApprove}
                  editButtonEvent={editButtonEvent}
                  restartButton={row[10] && !row[9] ? restartButton : false}
                  restartButtonEvent={row[10] && !row[9] ? restartButtonEvent : null}
                  widthColumn={widthColumn}
                />
              );
            })}
          </TableBody>
        </Table>
        <TablePagination
          labelRowsPerPage={t2('Pagination')}
          component="div"
          count={count}
          page={page}
          sx={tablePaginationStyle}
          onPageChange={handleChangePage}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </TableContainer>
    </div>
  );
}
